import {
    CORE_GET_ALL_DEVICE_REQUEST,
    CORE_GET_ALL_DEVICE_SUCCESS,
    CORE_GET_ALL_DEVICE_FAILURE,
    CORE_GET_DEVICE_REQUEST,
    CORE_GET_DEVICE_SUCCESS,
    CORE_GET_DEVICE_FAILURE,
    CORE_GET_DEVICE_INFO_REQUEST,
    CORE_GET_DEVICE_INFO_SUCCESS,
    CORE_GET_DEVICE_INFO_FAILURE,
    CORE_GET_DETAIL_TASKLIST_REQUEST,
    CORE_GET_DETAIL_TASKLIST_SUCCESS,
    CORE_GET_DETAIL_TASKLIST_FAILURE,
    CORE_CREATE_DEVICE_REQUEST,
    CORE_CREATE_DEVICE_SUCCESS,
    CORE_CREATE_DEVICE_FAILURE,
    CORE_UPDATE_DEVICE_REQUEST,
    CORE_UPDATE_DEVICE_SUCCESS,
    CORE_UPDATE_DEVICE_FAILURE,
    CORE_AUTH_VERIFY_PD_DEVICE_REQUEST,
    CORE_AUTH_VERIFY_PD_DEVICE_SUCCESS,
    CORE_AUTH_VERIFY_PD_DEVICE_FAILURE,
    REQUEST_STATE,
} from '../types';

const requestState = REQUEST_STATE;

export default {
    allDevice: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_DEVICE_REQUEST:
                return state;
            case CORE_GET_ALL_DEVICE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    }
                    return [];
                } else return [];
            case CORE_GET_ALL_DEVICE_FAILURE:
                return [];
            default:
                return state;
        }
    },
    device: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_REQUEST:
            case CORE_CREATE_DEVICE_REQUEST:
            case CORE_UPDATE_DEVICE_REQUEST:
            case CORE_AUTH_VERIFY_PD_DEVICE_REQUEST:
                return state;
            case CORE_GET_DEVICE_SUCCESS:
            case CORE_CREATE_DEVICE_SUCCESS:
            case CORE_UPDATE_DEVICE_SUCCESS:
            case CORE_AUTH_VERIFY_PD_DEVICE_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case CORE_GET_DEVICE_FAILURE:
            case CORE_CREATE_DEVICE_FAILURE:
            case CORE_UPDATE_DEVICE_FAILURE:
            case CORE_AUTH_VERIFY_PD_DEVICE_FAILURE:
                return {};
            default:
                return state;
        }
    },
    deviceInfo: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_INFO_REQUEST:
                return state;
            case CORE_GET_DEVICE_INFO_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case CORE_GET_DEVICE_INFO_FAILURE:
                return {};
            default:
                return state;
        }
    },

    taskListDetail: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DETAIL_TASKLIST_REQUEST:
                return state;
            case CORE_GET_DETAIL_TASKLIST_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    }
                    return {};
                } else return {};
            case CORE_GET_DETAIL_TASKLIST_FAILURE:
                return {};
            default:
                return state;
        }
    },
};



// WEBPACK FOOTER //
// ./src/app/redux/reducers/device.js